export const NOTIFICATION_DEFAULT = {
  isOpen: false,
  message: '',
  variant: '',
};
